module.exports = __webpack_public_path__ + "img/8.2c1d5943.png";